import Mail from "@assets/icons/mail.svg";
import { useI18n } from "@core/i18n/i18n";
import { analyticsService } from "@core/service-container";
import { AnalyticsCategory } from "@domain/analytics/analytics-types";
import styled from "@emotion/styled";
import { useCountryConfig } from "@ui/pages/patient-details/hooks/use-country-config";
import { colors } from "@ui/style/colors";
import React from "react";

type UiStyle = "primary" | "secondary";

interface ContactSupportProps {
	uiStyle?: UiStyle;
}

export const ContactSupport = ({ uiStyle = "primary" }: ContactSupportProps): JSX.Element => {
	const { format } = useI18n();
	const { countryConfig } = useCountryConfig();

	return (
		<ContactUsContainer
			uiStyle={uiStyle}
			onClick={() => {
				analyticsService.trackEvent({ category: AnalyticsCategory.COMMUNICATION, action: "contactCustomerSupport" });
				window.open(`mailto:${countryConfig?.customerSupportEmail}`);
			}}
		>
			<ContactUsTitle>{format("global.contactUs")}</ContactUsTitle>
			<Mail height={20} width={20} />
		</ContactUsContainer>
	);
};

const ContactUsContainer = styled.div<{ uiStyle: UiStyle }>`
	display: flex;
	place-items: center;
	cursor: pointer;
	color: ${({ uiStyle }) => (uiStyle === "primary" ? colors.primary : colors.grey)};
`;

const ContactUsTitle = styled.div`
	font-weight: 600;
	margin-right: 8px;
`;
